import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./TrackContent.css";
import Delivery from "./track/Delivery";
import Techversant from "./track/Techversant";
import Operations from "./track/Operations";
import Cloud from "./track/Cloud";
import Learning from "./track/Learning";
import Tower from "./track/Tower";
import AdminPage from "./Admin/AdminPage";
import DeleteUser from "./Admin/DeleteUser";
import mailData from "../Data/mailData.js";

function TrackContent() {
  const [displayTab, setDisplayTab] = useState("delivery");
  return (
    <>
      <div className="main-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/Track/track_banner.png"}
          alt="Banner"
          className="banner-img"
        />
        <div className="banner-content">
          <h1>Artifacts Submission</h1>
          {/* <p><i>Lorem ipsum is simply dummy text of the printing</i></p> */}
        </div>
      </div>

      {/* <div className="user-components"> */}
      <AdminPage></AdminPage>
      <DeleteUser></DeleteUser>
      {/* </div> */}


      <div className="track_main_div">
        <div className="innerWrapper">
          <div className="track_container">
            <p>
              QA champions of their respective track have to ensure upload of
              artifacts under artifacts section as per the defined frequency.
              Please refer to the process and template tab for list of Templates
              and the frequency.
            </p>
            {/* <h2>Artifacts Submission</h2> */}
          </div>
          <div className="track_tab_cont">
            <ul className="topTabs">
              <li
                className={
                  displayTab === "delivery"
                    ? "track-tab-active"
                    : "track-tab-inactive"
                }
                onClick={() => setDisplayTab("delivery")}
              >
                <Link to="/tracks">Delivery, Security and IE</Link>
                <span className="border"></span>
              </li>
              <li
                className={
                  displayTab === "techversant"
                    ? "track-tab-active"
                    : "track-tab-inactive"
                }
                onClick={() => {
                  setDisplayTab("techversant");
                }}
              >
                <Link to="/tracks">Tech Expressway and E&IT</Link>
                <span className="border"></span>
              </li>
              <li
                className={
                  displayTab === "operations"
                    ? "track-tab-active"
                    : "track-tab-inactive"
                }
                onClick={() => setDisplayTab("operations")}
              >
                <Link to="/tracks">Operations</Link>
                <span className="border"></span>
              </li>
              <li
                className={
                  displayTab === "cloud-engg"
                    ? "track-tab-active"
                    : "track-tab-inactive"
                }
                onClick={() => setDisplayTab("cloud-engg")}
              >
                <Link to="/tracks">Cloud Engineering</Link>
                <span className="border"></span>
              </li>
              <li
                className={
                  displayTab === "lis"
                    ? "track-tab-active"
                    : "track-tab-inactive"
                }
                onClick={() => setDisplayTab("lis")}
              >
                <Link to="/tracks">Learning Experiences</Link>
                <span className="border"></span>
              </li>
              <li
                className={
                  displayTab === "tower-x"
                    ? "track-tab-active"
                    : "track-tab-inactive"
                }
                onClick={() => setDisplayTab("tower-x")}
              >
                <Link to="/tracks">Tower X</Link>
              </li>
            </ul>
          </div>
          <div className="track_sub-tab">
            {displayTab === "delivery" ? (
              <div className="track_content">
                <Delivery />
              </div>
            ) : (
              ""
            )}
            {displayTab === "techversant" ? (
              <div className="track_content">
                <Techversant />
              </div>
            ) : (
              ""
            )}
            {displayTab === "operations" ? (
              <div className="track_content">
                <Operations />
              </div>
            ) : (
              ""
            )}
            {displayTab === "cloud-engg" ? (
              <div className="track_content">
                <Cloud />
              </div>
            ) : (
              ""
            )}
            {displayTab === "lis" ? (
              <div className="track_content">
                <Learning />
              </div>
            ) : (
              ""
            )}
            {displayTab === "tower-x" ? (
              <div className="track_content">
                <Tower />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div className="icons-container">
        <div className="icons-wrap">
          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"}
                  alt="Mailicon"
                  className="group-img mailIcon"
                  id="icon-chat"
                />
                <a
                  className="contact-us"
                  target="_blank"
                  href={`mailto: ${mailData.dellearningframework}`}
                >
                  <span className="menu-text">Write to us</span>
                </a>
                {/* <span className="contact-word">Mail</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="link_container_below">
        <div className="link_cont_wrap">
          <div>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Acc_GT_Dimensional_RGB.png"
              }
              alt="AccentureIcon"
              className="link_accenture_logo"
            />
          </div>
          <div className="link_text_cont">
            <span>
              For any queries or support, you may reach out to
              <a
                className="link_anchor"
                href={`mailto:${mailData.qualityassurance}`}
                target="_blank"
              >
                {" "}
                {mailData.qualityassurance}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default TrackContent;
